module.exports = __webpack_public_path__ + "static/10-Indoor-Game-Arena-5bc1064035fa5e059ed23bcd39fc952f.jpg";